export default __webpack_public_path__ + "static/1273-0895a4a5cb9d7195204c404bfc674248.gif";